/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CaptureTriggeredPayload
 */
export interface CaptureTriggeredPayload {
    [key: string]: any | any;
    /**
     * 
     */
    type: CaptureTriggeredPayloadTypeEnum;
    /**
     * 
     */
    captureId: string;
    /**
     * 
     */
    triggerSource: string;
}


/**
 * @export
 */
export const CaptureTriggeredPayloadTypeEnum = {
    CaptureTriggered: 'capture_triggered',
} as const;
export type CaptureTriggeredPayloadTypeEnum = typeof CaptureTriggeredPayloadTypeEnum[keyof typeof CaptureTriggeredPayloadTypeEnum];


/**
 * Check if a given object implements the CaptureTriggeredPayload interface.
 */
export function instanceOfCaptureTriggeredPayload(value: object): value is CaptureTriggeredPayload {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (value['type'] !== 'capture_triggered') return false;
    
    if ((!('captureId' in (value as Record<string, any>)) && !('capture_id' in (value as Record<string, any>))) || ((value as Record<string, any>)['captureId'] === undefined && (value as Record<string, any>)['capture_id'] === undefined)) return false;
    if ((!('triggerSource' in (value as Record<string, any>)) && !('trigger_source' in (value as Record<string, any>))) || ((value as Record<string, any>)['triggerSource'] === undefined && (value as Record<string, any>)['trigger_source'] === undefined)) return false;
    return true;
}

export function CaptureTriggeredPayloadFromJSON(json: any): CaptureTriggeredPayload {
    return CaptureTriggeredPayloadFromJSONTyped(json, false);
}

export function CaptureTriggeredPayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): CaptureTriggeredPayload {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'type': json['type'],
        'captureId': json['capture_id'],
        'triggerSource': json['trigger_source'],
    };
}

export function CaptureTriggeredPayloadToJSON(json: any): CaptureTriggeredPayload {
    return CaptureTriggeredPayloadToJSONTyped(json, false);
}

export function CaptureTriggeredPayloadToJSONTyped(value?: CaptureTriggeredPayload | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
            ...value,
        'type': value['type'],
        'capture_id': value['captureId'],
        'trigger_source': value['triggerSource'],
    };
}

